/**
 * TextZoomControl — compact A− / A / A+ text-size control for the footer.
 * Persists to localStorage via lib/textZoom and applies document zoom.
 */
import React, { useEffect, useState } from "react";
import { getZoom, setZoom, ZOOM_LEVELS } from "../lib/textZoom";

const TextZoomControl = () => {
  const [zoom, setZoomState] = useState(1);

  useEffect(() => {
    setZoomState(getZoom());
    const onChange = (e) => setZoomState(e.detail);
    window.addEventListener("ek-text-zoom-change", onChange);
    return () => window.removeEventListener("ek-text-zoom-change", onChange);
  }, []);

  const idx = ZOOM_LEVELS.indexOf(zoom);
  const decrease = () => setZoom(ZOOM_LEVELS[Math.max(0, idx - 1)]);
  const increase = () => setZoom(ZOOM_LEVELS[Math.min(ZOOM_LEVELS.length - 1, idx + 1)]);
  const reset = () => setZoom(1);

  return (
    <div
      className="inline-flex items-center gap-2 text-zinc-400"
      role="group"
      aria-label="Text size"
      data-testid="text-zoom-control"
    >
      <span className="text-[11px] tracking-[0.14em] uppercase text-zinc-500">Text size</span>
      <div className="inline-flex items-center border border-white/15">
        <button
          type="button"
          onClick={decrease}
          disabled={idx <= 0}
          aria-label="Decrease text size"
          className="px-2.5 py-1 text-[12px] hover:text-white disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid="text-zoom-smaller"
        >
          A−
        </button>
        <button
          type="button"
          onClick={reset}
          aria-label="Reset text size"
          className={`px-2.5 py-1 text-[13px] border-x border-white/15 hover:text-white ${zoom === 1 ? "text-white" : ""}`}
          data-testid="text-zoom-reset"
        >
          A
        </button>
        <button
          type="button"
          onClick={increase}
          disabled={idx >= ZOOM_LEVELS.length - 1}
          aria-label="Increase text size"
          className="px-2.5 py-1 text-[15px] hover:text-white disabled:opacity-40 disabled:cursor-not-allowed"
          data-testid="text-zoom-larger"
        >
          A+
        </button>
      </div>
    </div>
  );
};

export default TextZoomControl;
